import React from "react";
import PrivateRoute from "../config/privateRoute";

const Router = () => {
  return (
    <>
      <PrivateRoute />
    </>
  );
};

export default Router;
